import React from 'react'

import type { InventoryOrder } from '~/api/graphql/generated/types'

import { OrderItemsPageHeaderLabels } from './order-items/OrderItemsPageHeaderLabels'
import { getReceivedBy } from './utils'

interface OrderCardProps {
  inventoryOrder: InventoryOrder
}

export const OrderCard = ({ inventoryOrder }: OrderCardProps) => {
  const receivedBy = getReceivedBy(inventoryOrder)

  return (
    <OrderItemsPageHeaderLabels
      inventoryOrder={inventoryOrder}
      receivedBy={receivedBy}
    />
  )
}
